export const invoicePages = {
  root: {
    name: '/invoice/:id',
    navigate: (id: number) => `/invoice/${id}`,
  },
}
